module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-invoice-list row column"
  }, [_c('cards', {
    attrs: {
      "data": _vm.parsedReports
    }
  }), _c('invoice-list-form', {
    on: {
      "filterInvoices": _vm.setSearch
    }
  }), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search,
      "searchRangeDataLoader": _vm.getReports
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1175b424!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/InvoiceList.vue
// module id = 2152
// module chunks = 1